import type {ResidentMembership} from "../types/resident-membership";

export const RESIDENT_REDACTED_TOOLTIP =
  "Limited view for rented units. Tenant details are hidden in this summary.";

export function isResidentFieldRedacted(
  value: string | null | undefined,
  membership: ResidentMembership | null | undefined,
): boolean {
  return value === null && Boolean(membership?.is_owner && !membership.is_occupant);
}

export function formatResidentRedactedField(
  value: string | null | undefined,
  membership: ResidentMembership | null | undefined,
  fallback = "—",
): {text: string; isRedacted: boolean} {
  if (isResidentFieldRedacted(value, membership)) {
    return {text: "Hidden", isRedacted: true};
  }

  const trimmed = value?.trim();
  return {text: trimmed || fallback, isRedacted: false};
}
